import { render } from "./signup-step-supporter-interests.vue?vue&type=template&id=04bd836d&scoped=true&ts=true"
import script from "./signup-step-supporter-interests.vue?vue&type=script&lang=ts"
export * from "./signup-step-supporter-interests.vue?vue&type=script&lang=ts"

import "./signup-step-supporter-interests.vue?vue&type=style&index=0&id=04bd836d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bd836d"]])

export default __exports__